import { Navigate, Outlet } from 'react-router-dom';
import { useAuth } from '../../../context/AuthContext';
import { AppRoutes } from '../../../routes/routeConstants/appRoutes';
import { AccessRequirements } from '../../utils/accessControl';

interface AccessGuardProps extends AccessRequirements {
  redirectTo?: string;
}

// Layout route guard — nest the routes it protects inside this route's element.
// Redirecting during render keeps the guarded route from mounting at all.
const AccessGuard = ({ allowedRoles, redirectTo = AppRoutes.HOME }: AccessGuardProps) => {
  const { canAccess } = useAuth();

  return canAccess({ allowedRoles }) ? <Outlet /> : <Navigate to={redirectTo} replace />;
};

export default AccessGuard;
